import { Link } from "react-router-dom";
import localeText from "../../../../locale";
import { useLocation } from "react-router-dom";

const ProductInfoFooter = (props) => {
  const locationUrl = useLocation();

  const isFringeBenefitsPage = locationUrl?.pathname?.toLowerCase()?.includes("fringe");

  return (
    <div className="flex gap-2 align-items-center">
      {props?.storeName && (
        <div className="flex gap-1 align-items-center text-xs">
          <div className="flex align-items-center" style={{ color: "#7A869A" }}>
            <i className="pi pi-shop mr-2" />
            {localeText("soldBy")}
          </div>
          <Link
            to={`/store?user=${props?.product?.user?.username}`}
            className="font-semibold underline"
            style={{ color: "#245AE5" }}
          >
            {props?.storeName}
          </Link>
        </div>
      )}
      {!isFringeBenefitsPage && (
        <>
          {props?.productInfo.data.product.sendBy === "SELLER" ? (
            <>
              {!props?.product?.downloadable && !props?.product?.service && (
                <div
                  style={{ color: "#245AE5" }}
                  className="flex align-items-center gap-2 text-xs font-medium"
                >
                  {props?.storeName && <span style={{ color: "#7A869A" }}>|</span>}{" "}
                  <i className="pi pi-truck" /> {`${props?.freightText}`}{" "}
                  {props?.freightType === "PICKUP" && (
                    <span>
                      -{" "}
                      <span className="cursor-pointer" onClick={props?.openStoreLocationModal}>
                        {localeText("seeAtMap")}
                      </span>
                    </span>
                  )}
                </div>
              )}
            </>
          ) : (
            <>
              {!props?.product?.downloadable && !props?.product?.service && (
                <div
                  style={{ color: "#245AE5" }}
                  className="flex align-items-center gap-2 text-xs font-medium"
                >
                  {props?.storeName && <span style={{ color: "#7A869A" }}>|</span>}{" "}
                  <i className="pi pi-truck" /> {`${props?.freightText}`}{" "}
                  {props?.freightType === "PICKUP" && (
                    <span>
                      -{" "}
                      <span className="cursor-pointer" onClick={props?.openStoreLocationModal}>
                        {localeText("seeAtMap")}
                      </span>
                    </span>
                  )}
                </div>
              )}
            </>
          )}
        </>
      )}
    </div>
  );
};

export default ProductInfoFooter;
